import { HttpClient } from '@angular/common/http';
import { Data, Response, waitAndRetry } from '@dimandzhi/graphql';
import { currentMethodName } from 'app/current-method-name';
import { GraphQL } from 'app/graphql';
import { environment as env } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

export class UsersInCurrentGroup {
  private usersInCurrentGroupFirstCall: boolean;
  private usersInCurrentGroup: BehaviorSubject<GraphQL.UserSchema.UserInGroup[]>;

  constructor(
    protected http: HttpClient
  ) { }

  initUsersInCurrentGroup() {
    this.usersInCurrentGroupFirstCall = true;
    this.usersInCurrentGroup = new BehaviorSubject<GraphQL.UserSchema.UserInGroup[]>([]);
  }

  getUsersInCurrentGroup(): Observable<GraphQL.UserSchema.UserInGroup[]>;
  getUsersInCurrentGroup(asSnapshot: boolean): GraphQL.UserSchema.UserInGroup[];
  getUsersInCurrentGroup(asSnapshot?: boolean) {
    if (this.usersInCurrentGroupFirstCall) {
      this.refreshUsersInCurrentGroup();
      this.usersInCurrentGroupFirstCall = false;
    }
    if (asSnapshot) {
      return this.usersInCurrentGroup.getValue();
    }
    return this.usersInCurrentGroup.asObservable();
  }

  private refreshUsersInCurrentGroup() {
    this.http.post<Response>(`${env.graphqlUser}/${currentMethodName()}`, `
      query {
        User {
          inCurrentGroup {
            id
            firstName
            lastName
            email
            enabled
            isManager
          }
        }
      }`
    ).pipe(waitAndRetry, Data.fromResp).subscribe({
      next: data =>
        this.usersInCurrentGroup.next(GraphQL.UserSchema.UserInGroup.fromData(data, 'inCurrentGroup')),
      error: err => this.usersInCurrentGroup.error(err),
    });
  }
}
